import styled from 'styled-components';
import { getTextColor } from '@magalu/stereo-ui-styles';
import { Text } from '../../../atoms';
export const ProductShippingCost = styled(Text).attrs(() => ({
  fontSize: 0,
  fontWeight: 'regular',
  marginTop: 1
}))`
  color: ${getTextColor('scratched')};
`;
export const Container = styled.div``;